import React from "react";
import { connect } from 'react-redux';
import axios from 'axios'
import {getCurrentUserSuccess} from '../../actions/session';
import {setErrorMessage, resetErrors} from '../../actions';
import { getHeader } from "../../helper";

class PassportData extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formEdit: false
        }
    }

    onEdit(e) {
        const form = this.refs.form;

        this.setState({
            formEdit: !this.state.formEdit
        }, () => {
            form.querySelectorAll(".value").forEach(item => 
                this.state.formEdit ? item.removeAttribute("disabled") : item.setAttribute("disabled", "disabled")
            )
        });
    }

    onSubmit(e){
            e.preventDefault()
            const { currentUser, token } = this.props.session;

            const payload ={} 
            for (const key in this.refs){
                const val = this.refs[key].value
                if (!val) continue;
                payload[key] = val
            }
            axios.patch(
                `${window.siteUrl}/api/v1/user/${currentUser.id}/`,
                payload,
                {
                    headers: getHeader()
                }
            )
            .then(response => {
                this.props.getCurrentUserSuccess(payload)
                this.onEdit()
                this.props.resetErrors()
                
            }) 
            .catch(error=> {
                this.props.setErrorMessage(error.response.data)
            });
        }
    
    
    render() {
        const { session, errorMessages } = this.props;

        const {
            inn,
            passport_number,
            passport_who,
            passport_address,
            passport_date_at,
            birthday_at
        } = session.currentUser;

        return  (
                <div className="right-content native-scroll right-content-bottom right-content-width">
                    <div className="screen-outer-block-wrap native-scroll menu-content">
                        <div className="menu-content-passport-data menu-content-item tab-parent screen-bottom-block">
                            <div className="rounded-white-block">
                                <div className="white-block-content">
                                    <ul ref="form" className="data-with-labels">
                                        <li>
                                            <label htmlFor="">Серия и номер паспорта</label>
                                            {
                                                !this.state.formEdit
                                                ? <div className="value-disabled">{passport_number || "Не указано"}</div>
                                                : <input ref="passport_number" type="text" className="value" defaultValue={passport_number || ""} />
                                            }
                                            {
                                                errorMessages && errorMessages.passport_number 
                                                ? errorMessages.passport_number.map((text, index) =>
                                                    <span key={index} className="input-error-text">{text}</span>
                                                )
                                                : ''
                                            }
                                        </li>
                                        <li>
                                            <label htmlFor="">Кем выдан паспорт</label>
                                            {
                                                !this.state.formEdit
                                                ? <div className="value-disabled">{passport_who || "Не указано"}</div>
                                                : <input ref="passport_who" type="text" className="value" defaultValue={passport_who || ""} />
                                            }
                                            {
                                                errorMessages && errorMessages.passport_who 
                                                ? errorMessages.passport_who.map((text, index) =>
                                                    <span key={index} className="input-error-text">{text}</span>
                                                )
                                                : ''
                                            }  
                                        </li>

                                        <li>
                                            <label htmlFor="">Когда выдан паспорт</label>
                                            {
                                                !this.state.formEdit
                                                ? <input type={passport_date_at && passport_date_at.length ? "date" : "text"} className="value" disabled value={passport_date_at && passport_date_at.length ? passport_date_at : "Не указано"} />
                                                : <input ref="passport_date_at" type="date" className="value" defaultValue={passport_date_at || ""} />
                                            }
                                            {
                                                errorMessages && errorMessages.passport_date_at 
                                                ? errorMessages.passport_date_at.map((text, index) =>
                                                    <span key={index} className="input-error-text">{text}</span>
                                                )
                                                : ''
                                            }  
                                        </li>

                                        <li>
                                            <label htmlFor="">Прописка по паспорту</label>
                                            {
                                                !this.state.formEdit
                                                ? <div className="value-disabled">{passport_address || "Не указано"}</div>
                                                : <input ref="passport_address" type="text" className="value" defaultValue={passport_address || ""} />
                                            }
                                            {
                                                errorMessages && errorMessages.passport_address 
                                                ? errorMessages.passport_address.map((text, index) =>
                                                    <span key={index} className="input-error-text">{text}</span>
                                                )
                                                : ''
                                            }  
                                        </li>

                                        <li>
                                            <label htmlFor="">Дата рождения</label>
                                            {
                                                !this.state.formEdit
                                                ? <input type={birthday_at && birthday_at.length ? "date" : "text"} className="value" disabled value={birthday_at && birthday_at.length ? birthday_at : "Не указано"} />
                                                : <input ref="birthday_at" type="date" className="value" defaultValue={birthday_at || ""} />
                                            }
                                            {
                                                errorMessages && errorMessages.birthday_at 
                                                ? errorMessages.birthday_at.map((text, index) =>
                                                    <span key={index} className="input-error-text">{text}</span>
                                                )
                                                : ''
                                            }  
                                        </li>

                                        <li>
                                            <label htmlFor="">ИНН</label>
                                            {
                                                !this.state.formEdit
                                                ? <div className="value-disabled">{inn || "Не указан"}</div>
                                                : <input ref="inn" type="text" placeholder="Ваш ИНН" className="value" defaultValue={inn || ""} />
                                            }
                                            {
                                                errorMessages && errorMessages.inn 
                                                ? errorMessages.inn.map((text, index) =>
                                                    <span key={index} className="input-error-text">{text}</span>
                                                )
                                                : ''
                                            }
                                        </li>
                                    </ul>

                                    <div className="actions">
                                        <div className="big-button empty-button">
                                            <button onClick={this.onEdit.bind(this)}>
                                                {this.state.formEdit ? 'Отмена' : 'Редактировать'}
                                            </button>
                                        </div>
                                        {this.state.formEdit ?                         
                                        <div className="big-button">
                                            <button  onClick={this.onSubmit.bind(this)}>Сохранить</button>
                                        </div> : null
                                        }
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

export default connect(
    state => ({
        ...state
    }),
    {
        getCurrentUserSuccess,
        setErrorMessage,
        resetErrors
    }
)(PassportData);




// WEBPACK FOOTER //
// ./src/components/Account/PassportData.js